
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import Index from "./pages/Index";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import SignupThankYou from "./pages/SignupThankYou";
import ResetPassword from "./pages/ResetPassword";
import BreederDashboard from "./pages/BreederDashboard";
import BuyerDashboard from "./pages/BuyerDashboard";
import AdminDashboard from "./pages/AdminDashboard";
import Marketplace from "./pages/Marketplace";
import ListingDetail from "./pages/ListingDetail";
import AnnouncementDetail from "./pages/AnnouncementDetail";
import BreederProfile from "./pages/BreederProfile";
import BuyerProfile from "./pages/BuyerProfile";
import Breeders from "./pages/Breeders";
import AddListing from "./pages/AddListing";
import EditListing from "./pages/EditListing";
import Terms from "./pages/Terms";
import Privacy from "./pages/Privacy";
import NotFound from "./pages/NotFound";
import Pricing from "./pages/Pricing";
import Auctions from "./pages/Auctions";
import { ScrollToTop } from "./components/ScrollToTop";
import { RouteErrorBoundary } from "./components/RouteErrorBoundary";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30 * 1000,
      retry: 1,
      refetchOnWindowFocus: true,
    },
  },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
        <TooltipProvider>
          <Toaster />
          <Sonner />
          <BrowserRouter>
            <AuthProvider>
              <ScrollToTop />
              <Routes>
                <Route path="/" element={<Index />} />
                <Route path="/login" element={<Login />} />
                <Route path="/signup" element={<Signup />} />
                <Route path="/signup-thank-you" element={<SignupThankYou />} />
                <Route path="/reset-password" element={<ResetPassword />} />
                <Route path="/pricing" element={<Pricing />} />
                <Route
                  path="/breeder-dashboard"
                  element={
                    <RouteErrorBoundary>
                      <BreederDashboard />
                    </RouteErrorBoundary>
                  }
                />
                <Route
                  path="/buyer-dashboard"
                  element={
                    <RouteErrorBoundary>
                      <BuyerDashboard />
                    </RouteErrorBoundary>
                  }
                />
                <Route
                  path="/admin-dashboard"
                  element={
                    <RouteErrorBoundary>
                      <AdminDashboard />
                    </RouteErrorBoundary>
                  }
                />
                <Route path="/marketplace" element={<Marketplace />} />
                <Route path="/auctions" element={<Auctions />} />
                <Route path="/listing/:id" element={<ListingDetail />} />
                <Route path="/announcement/:id" element={<AnnouncementDetail />} />
                <Route path="/breeder/:id" element={<BreederProfile />} />
                <Route path="/buyer/:id" element={<BuyerProfile />} />
                <Route path="/breeders" element={<Breeders />} />
                <Route path="/add-listing" element={<AddListing />} />
                <Route path="/edit-listing/:id" element={<EditListing />} />
                <Route path="/terms" element={<Terms />} />
                <Route path="/privacy" element={<Privacy />} />
                <Route path="*" element={<NotFound />} />
              </Routes>
            </AuthProvider>
          </BrowserRouter>
        </TooltipProvider>
      </QueryClientProvider>
  );
}

export default App;
